"use strict";
/**
 * MHub client library using native browser WebSocket.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var events = require("events");
var ts_promise_1 = require("ts-promise");
var baseclient_1 = require("./baseclient");
var DEFAULT_PORT_WS = 13900;
var DEFAULT_PORT_WSS = 13901;
exports.defaultClientOptions = {};
var CLOSE_GOING_AWAY = 1001; // https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
var WebSocketConnection = /** @class */ (function (_super) {
    __extends(WebSocketConnection, _super);
    function WebSocketConnection(url) {
        var _this = _super.call(this) || this;
        _this._socket = new WebSocket(url);
        _this._socket.addEventListener("error", function (e) { return _this.emit("error", e); });
        _this._socket.addEventListener("open", function () {
            _this.emit("open");
        });
        _this._socket.addEventListener("close", function () {
            _this.emit("close");
        });
        _this._socket.addEventListener("message", function (event) {
            if (!event.data) {
                // Ignore empty 'lines'
                return;
            }
            var response = JSON.parse(event.data);
            _this.emit("message", response);
        });
        return _this;
    }
    /**
     * Transmit data object.
     * @return Promise that resolves when transmit is accepted (i.e. not necessarily
     * arrived at other side, can be e.g. queued).
     */
    WebSocketConnection.prototype.send = function (data) {
        var _this = this;
        return new ts_promise_1.default(function (resolve) {
            _this._socket.send(JSON.stringify(data));
            resolve(undefined);
        });
    };
    /**
     * Gracefully close connection, i.e. allow pending transmissions
     * to be completed.
     * @return Promise that resolves when connection is succesfully closed.
     */
    WebSocketConnection.prototype.close = function (code) {
        var _this = this;
        var result;
        if (!this._connected) {
            result = ts_promise_1.default.resolve();
        }
        else {
            result = new ts_promise_1.default(function (resolve) {
                _this._socket.addEventListener("close", function () { return resolve(undefined); });
            });
        }
        this._socket.close(code);
        return result;
    };
    /**
     * Forcefully close connection.
     * @return Promise that resolves when connection is succesfully closed.
     */
    WebSocketConnection.prototype.terminate = function () {
        return this.close(CLOSE_GOING_AWAY);
    };
    Object.defineProperty(WebSocketConnection.prototype, "_connected", {
        get: function () {
            return this._socket.readyState === WebSocket.CONNECTING || this._socket.readyState === WebSocket.OPEN;
        },
        enumerable: true,
        configurable: true
    });
    return WebSocketConnection;
}(events.EventEmitter));
/**
 * MHub client using server-side WebSocket.
 *
 * Allows subscribing and publishing to MHub server nodes.
 *
 * @event open() Emitted when connection was established.
 * @event close() Emitted when connection was closed.
 * @event error(e: Error) Emitted when there was a connection, server or protocol error.
 * @event message(m: Message) Emitted when message was received (due to subscription).
 */
var MClient = /** @class */ (function (_super) {
    __extends(MClient, _super);
    /**
     * Create new connection to MServer.
     * @param url Websocket URL of MServer, e.g. ws://localhost:13900
     * @param options Optional options, see `MClientOptions`.
     */
    function MClient(url, options) {
        var _this = this;
        // Ensure options is an object and fill in defaults
        options = __assign({}, exports.defaultClientOptions, options);
        // Prefix URL with "ws://" if needed
        if (url.indexOf("://") < 0) {
            url = "ws://" + url;
        }
        // Append default port if necessary
        if (!url.match(":\\d+$")) {
            var useTls = url.indexOf("wss://") === 0;
            url = url + ":" + (useTls ? DEFAULT_PORT_WSS : DEFAULT_PORT_WS);
        }
        _this = _super.call(this, function () { return new WebSocketConnection(url); }, options) || this;
        _this._url = url;
        return _this;
    }
    Object.defineProperty(MClient.prototype, "url", {
        /**
         * Full URL of MHub connection.
         */
        get: function () {
            return this._url;
        },
        enumerable: true,
        configurable: true
    });
    return MClient;
}(baseclient_1.BaseClient));
exports.MClient = MClient;
exports.default = MClient;
//# sourceMappingURL=browserclient.js.map